import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV, SERVICES } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-24 border-t border-white/10 bg-slate-950">
      <div className="pointer-events-none absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent" />
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 grid gap-12 lg:grid-cols-4">
        <div className="lg:col-span-2 max-w-md">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-400 to-violet-500">
              <span className="absolute inset-[2px] rounded-[10px] bg-slate-950 flex items-center justify-center font-display text-sm font-black text-cyan-300">
                DP
              </span>
            </span>
            <div>
              <div className="font-display font-bold text-white text-lg">
                DevOps<span className="text-cyan-400">Pro</span>Cloud <span className="text-slate-500 text-xs font-mono-plex">Inc.</span>
              </div>
              <div className="font-mono-plex text-[10px] tracking-[0.3em] text-slate-500 uppercase">
                Cloud · Secure · Scale
              </div>
            </div>
          </Link>
          <p className="mt-5 text-slate-400 text-[15px] leading-relaxed">
            {COMPANY.tagline} We help SaaS, healthcare, retail and startups migrate,
            secure and scale on AWS, Azure and GCP.
          </p>
          <div className="mt-6 space-y-2.5 text-sm">
            <a href={COMPANY.phoneHref} className="flex items-center gap-2.5 text-slate-300 hover:text-cyan-300">
              <Phone size={15} className="text-cyan-400" /> {COMPANY.phone}
            </a>
            <a href={COMPANY.emailHref} className="flex items-center gap-2.5 text-slate-300 hover:text-cyan-300">
              <Mail size={15} className="text-cyan-400" /> {COMPANY.email}
            </a>
            <div className="flex items-center gap-2.5 text-slate-400">
              <MapPin size={15} className="text-cyan-400" /> {COMPANY.address}
            </div>
          </div>
        </div>

        <div>
          <div className="eyebrow mb-4">Company</div>
          <ul className="space-y-2.5">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-slate-300 hover:text-cyan-300 text-sm">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Services</div>
          <ul className="space-y-2.5">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="text-slate-300 hover:text-cyan-300 text-sm">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} DevOps Pro Cloud Inc. All rights reserved.</div>
          <div className="font-mono-plex tracking-wider">
            Built with production-grade DevOps · King of Prussia, PA
          </div>
          <Link to="/contact" className="inline-flex items-center gap-1 text-cyan-300 hover:text-cyan-200">
            Start a project <ArrowUpRight size={13} />
          </Link>
        </div>
      </div>
    </footer>
  );
}
